import React, { useState, useEffect, useMemo, useRef } from 'react'
import Moment from 'moment'
import _ from 'lodash'
import TimeZone from 'moment-timezone'
import {
  ModalHeader,
  ModalBody,
  ListGroupItem,
  ListGroup,
  Row, Col,
  UncontrolledTooltip,
  Button,
  ModalFooter,
  Label, FormGroup,
  Modal
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import ReactSelect from 'react-select';

import Lang from 'Lang/General'
import AllDays from './AllDays'
import './index.scss'

import { timeToMinutes, isValidTimeslots } from 'utils/timeToMinute'

function findOverlappingTimeslots(week_days) {
  const overlaps = {};

    let temp = _.cloneDeep(week_days);
    temp.forEach((day) => {
      const { week_day, timeslots } = day;

      if( timeslots ){
        timeslots.sort((a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time));
  
        for (let i = 0; i < timeslots.length - 1; i++) {
          const current = timeslots[i];
          const next = timeslots[i + 1];
  
          if (timeToMinutes(current.end_time) > timeToMinutes(next.start_time)) {
            overlaps[week_day] = {
              overlap_indices: [i, i + 1],
              overlap_between: [current, next]
            }
          }
        }
      }
    });

  return overlaps;
}

function OperatingSlotForm({
  lang,
  selectedEditTimeZone,
  onClose,
  onSubmit
}) {
  const containerRef = useRef(null);
  const [timeError, setTimeError] = useState(false);
  const [tempZone, setTempZone] = useState({
    week_days: [],
    timezone: null
  })
  const [showEditAll, setEditAll] = useState(false)

  useEffect(() => {
    setTempZone(selectedEditTimeZone)
  }, [selectedEditTimeZone])

  const errors = useMemo(() => {
    let temp = findOverlappingTimeslots(tempZone.week_days)

    return temp
  }, [tempZone])

  const onChangeSlot = (index, slotIndex, context, val) => {
    let temp = _.cloneDeep(tempZone)
    temp.week_days[index].timeslots[slotIndex][context] = val

    setTempZone(temp)
  }

  const onRemoveSlot = (index, slotIndex) =>  {
    let temp = _.cloneDeep(tempZone)
    temp.week_days[index].timeslots.splice(slotIndex, 1)

    setTempZone(temp)
  }

  const onAddSlot = (index) =>  {
    let temp = _.cloneDeep(tempZone)
    temp.week_days[index].timeslots = temp.week_days[index].timeslots || []
    temp.week_days[index].timeslots.push({
      start_time: '00:00',
      end_time: '01:00'
    })

    setTempZone(temp)
  }

  useEffect(() => {
    setTimeError(!isValidTimeslots(tempZone))
  }, [tempZone])

  return (
    <>
      <ModalHeader
        toggle={() => onClose()} 
      >
        {Lang['EDIT_OPERATING_HOUR'][lang]}
      </ModalHeader>
      <ModalBody>
        <div className="d-flex">
          <Button
            onClick={() => setEditAll(true)}
            className="ml-auto"
          >
            {Lang['EDIT_ALL'][lang]}
          </Button>
        </div>
        <FormGroup>
          <Label>
            {Lang['TIMEZONE'][lang]}
          </Label>
          <ReactSelect
            options={_.map(TimeZone.tz.names(), child => ({
              value: child,
              label: child
            }))}
            value={
              tempZone.timezone 
                ? {value: tempZone.timezone, label: tempZone.timezone }
                : null
            }
            onChange={val => setTempZone({
              ... tempZone,
              timezone: val.value
            })}
            styles={{
              menu: provided => ({ ...provided, zIndex: 999 }),
              menuPortal: provided => ({ ...provided, zIndex: 999 })
            }}
          />
        </FormGroup>
        <ListGroup style={{ maxHeight: "100%", overflow: 'scroll' }}>
          <ListGroupItem>
            <Row style={{ padding: '7px 0px' }}>
              <Col md={3}>
                <span>{Lang['OPERATING_HOUR'][lang]}</span>
              </Col>
              <Col md={9}>
              </Col>
            </Row>
            <hr />
          </ListGroupItem>
          <div ref={containerRef}>
          {
            tempZone?.week_days.map((child, childIndex) => (
              <>
                <ListGroupItem>
                  <Row style={{ padding: '7px 0px' }}>
                    <Col md={3}>
                      <span>
                        {Moment().day(child.week_day).locale( lang ).format( 'dddd' )}
                      </span>
                    </Col>
                    <Col md={9} className="d-flex flex-wrap align-items-center">
                      {
                        child.timeslots?.map((slotChild, slotIndex) => (
                          <div className={`mb-2 ${
                            timeToMinutes(slotChild.start_time) > timeToMinutes(slotChild.end_time) ? 'custom-error-time' : ''
                          }`} style={{ 
                            padding: 5,
                            ... (!_.isEmpty(errors) && 
                            _.findIndex(errors?.[Number(child.week_day)]?.['overlap_between'], child => (child.start_time === slotChild.start_time && child.end_time === slotChild.end_time)) > -1
                          ) ? {
                              border: "1px solid red",
                              borderRadius: 5
                            } : {}
                          }}>
                            <div className="d-flex align-items-center" style={{ gap: 10 }}>
                              <DatePicker
                                className={'form-control'}
                                selected={ new Date(`1970-01-01T${ slotChild.start_time }:00`) }
                                onChange={ val => onChangeSlot(childIndex, slotIndex, 'start_time', Moment(val).format('HH:mm'))}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={ 15 }
                                timeCaption='Time'
                                dateFormat='HH:mm'
                                timeFormat='HH:mm'
                              />
                              <span>{` - `}</span>
                              <DatePicker
                                selected={ new Date(`1970-01-01T${ slotChild.end_time }:00`) }
                                className={'form-control'}
                                onChange={ val => onChangeSlot(childIndex, slotIndex,'end_time', Moment(val).format('HH:mm'))}
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={ 15 }
                                timeCaption='Time'
                                dateFormat='HH:mm'
                                timeFormat='HH:mm'
                              />
                              <i 
                                id={ `slot-delete-btn-${slotIndex}` }
                                className="pe-7s-trash" 
                                style={{ fontSize: '23px', color: '#dc3545' }} 
                                onClick={ () => onRemoveSlot(childIndex, slotIndex)}
                              />
                              <UncontrolledTooltip
                                target={ `slot-delete-btn-${slotIndex}` }
                                placement="top">
                                { Lang[ 'DELETE' ][ lang ] }
                              </UncontrolledTooltip>
                              {
                                (
                                  (
                                    ( (slotIndex + 1) === child.timeslots.length ) && 
                                    ( timeToMinutes(slotChild.start_time) < timeToMinutes(slotChild.end_time) )
                                  )
                                ) && (
                                  <>
                                    <i 
                                      id={ `slot-add-btn-${child.week_day}` }
                                      className={`pe-7s-plus text-success ml-2 ${errors?.[Number(child.week_day)] !== undefined ? 'd-none' : ''}`}
                                      style={{ fontSize: '23px' }} 
                                      onClick={ () => onAddSlot(child.week_day)}
                                    />
                                    <UncontrolledTooltip
                                      target={ `slot-add-btn-${child.week_day}` }
                                      placement="top">
                                      { Lang[ 'ADD' ][ lang ] }
                                    </UncontrolledTooltip>
                                  </>
                                )
                              }
                            </div>
                          </div>
                        ))
                      }
                      {
                        ( !child.timeslots || child.timeslots.length === 0 ) && (
                          <>
                            <i 
                              id={ `slot-add-btn-${child.week_day}` }
                              className={`pe-7s-plus text-success ml-2 ${errors?.[Number(child.week_day)] !== undefined ? 'd-none' : ''}`}
                              style={{ fontSize: '23px' }} 
                              onClick={ () => onAddSlot(child.week_day)}
                            />
                            <UncontrolledTooltip
                              target={ `slot-add-btn-${child.week_day}` }
                              placement="top">
                              { Lang[ 'ADD' ][ lang ] }
                            </UncontrolledTooltip>
                          </>
                        )
                      }
                    </Col>
                  </Row>
                  <hr />
                </ListGroupItem>
              </>
            ))
          }
          </div>
        </ListGroup>
        {
          showEditAll && (
            <Modal
              isOpen={true}
              size="lg"
            >
              <AllDays
                onClose={() => setEditAll(false)}
                lang={lang}
                onSubmit={val => {
                  let tempWeekDays = []
                  tempZone.week_days.map(day => tempWeekDays.push({
                    ... day,
                    timeslots: _.map(val, (child, childIndex) => ({
                      ... day.timeslots[childIndex],
                      ... child
                    }))
                  }))
                  
                  setTempZone({
                    ... tempZone,
                    week_days: tempWeekDays
                  })
                }}
              />
            </Modal>
            )
          }
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!_.isEmpty(errors) || timeError}
          onClick={ () => {
            onSubmit(tempZone)
          }}
        >
          {Lang['SUBMIT'][lang]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default OperatingSlotForm